<style lang="scss">
.slide-23 {
  background-image: url(../../../assets/module1/slide23/background-05.jpg);
  background-position: center;
  background-size: cover;
  padding-left: 50px;
  padding-top: 70px;
  height: calc(100% - 70px);
  h2 {
    font-size: 74px;
    color: #613384;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 120px;
    top: 190px;
    span {
      display: block;
      transform: rotate(-4deg);
      &:last-of-type {
        transform: rotate(-2deg) translateX(-60px);
      }
    }
  }
  .content {
    max-width: 545px;
    margin-left: 210px;
    margin-top: 450px;
  }
  p {
    margin-bottom: 50px;
  }
  h1 {
    color: #3b7fc2;
    font-size: 50px;
    position: absolute;
    top: 120px;
    left: 120px;
    &:last-of-type {
      top: 380px;
      left: 150px;
    }
    span {
      display: block;
      &:last-of-type {
        transform: translateX(50px);
      }
    }
  }
  h3 {
    color: #edad0a;
    font-size: 74px;
    margin-top: 0;
    margin-bottom: 30px;
    span {
      color: #e30613;
      font-size: 90px;
      transform: translateY(-15px);
    }
  }
  .btn {
    transition: all 0.2s ease-out;
    display: block;
    width: 300px;
    position: absolute;
    left: 775px;
    bottom: 295px;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>

<template>
  <div class="slide-23">
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 22"
        src="@/assets/module1/slide23/posters-10.png"
        class="chars delay-5"
      />
    </transition>
    <transition name="fadeUp" appear>
      <h1 v-show="slideIndex == 22" v-html="$t('module1.slide23.heading')"></h1>
    </transition>
    <transition name="fadeUp" appear>
      <h2
        v-show="slideIndex == 22"
        class="delay-1"
        v-html="$t('module1.slide23.heading2')"
      ></h2>
    </transition>
    <transition name="fadeUp" appear>
      <h1
        v-show="slideIndex == 22"
        class="delay-2"
        v-html="$t('module1.slide23.heading3')"
      ></h1>
    </transition>
    <div class="content">
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 22" class="delay-3">
          <p>{{ $t("module1.slide23.paragraph") }}</p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 22" class="delay-4">
          <p>{{ $t("module1.slide23.paragraph2") }}</p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 22" class="delay-5">
          <p v-html="$t('module1.slide23.paragraph3')"></p>
        </div>
      </transition>
      <transition name="scale" appear>
        <a
          v-show="slideIndex == 22"
          class="btn delay-6 duration-1"
          :href="pdfLink"
          target="_blank"
        >
          <img src="@/assets/module1/slide23/download_btn.svg" />
        </a>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    slideIndex: { type: Number },
    imageBlob: { type: String, default: undefined },
    imageId: { type: String, default: "0" },
    downloadLegacy: { type: Function, default: null }
  },
  data: () => {
    return {
      pdfLink:
        window?.CF_EBOOK_VARS?.documents?.book_1_document_1?.url ||
        "../Week-1-Activity-Card-COLOUR-Asset-3_Page_1.png"
    };
  },
  methods: {}
};
</script>
